// Dr. Nape site — shared behavior for every page

// mobile menu
const burger = document.getElementById('burger'), nav = document.getElementById('nav');
if (burger) {
  burger.addEventListener('click', () => { const o = nav.classList.toggle('open'); burger.setAttribute('aria-expanded', o); });
  nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { nav.classList.remove('open'); burger.setAttribute('aria-expanded', false); }));
}

// search (site-wide quick finder)
const SEARCH = [
  { t: 'Dr. Nape™ Classic', d: 'EMS + heat · 2 contact pads', u: '/products/dr-nape-classic', k: 'classic basic f6 cheap neck massager ems heat' },
  { t: 'Dr. Nape™ Pro', d: 'EMS + heat · 6 contact heads', u: '/products/dr-nape-pro', k: 'pro premium 1628 six heads red glow neck massager' },
  { t: 'Conductive Gel', d: '30 ml, included with every collar', u: '/products/dr-nape-pro#gel', k: 'gel conductive cream zap prickly aloe' },
  { t: 'How it works', d: 'EMS pulse + warming heat', u: '/#how', k: 'how works ems pulse heat modes' },
  { t: 'FAQ', d: 'Fit, safety, shipping, returns', u: '/pages/faq', k: 'faq questions fit safety pacemaker shipping delivery return refund charge usb' },
  { t: 'Science', d: 'What EMS is and how it has been studied', u: '/pages/science', k: 'science research study ems tens' },
  { t: 'Contact Us', d: 'Orders, product questions, wholesale', u: '/pages/contact', k: 'contact support email help order wholesale' },
];
const sBox = document.getElementById('search'), sIn = document.getElementById('search-input'), sList = document.getElementById('search-results');
function renderSearch() {
  const q = sIn.value.trim().toLowerCase();
  const hits = SEARCH.filter(i => !q || (i.t + ' ' + i.d + ' ' + i.k).toLowerCase().includes(q));
  sList.innerHTML = hits.length
    ? hits.map(i => `<li><a href="${i.u}"><span>${i.t}</span><small>${i.d}</small></a></li>`).join('')
    : `<li class="empty">No results for “${sIn.value.replace(/[<>&"]/g, '')}”. Try “gel”, “shipping” or “Pro”.</li>`;
}
function openSearch() { sBox.hidden = false; sIn.value = ''; renderSearch(); sIn.focus(); }
function closeSearch() { sBox.hidden = true; }
document.getElementById('search-open')?.addEventListener('click', openSearch);
document.getElementById('search-close')?.addEventListener('click', closeSearch);
sBox?.addEventListener('click', e => { if (e.target === sBox) closeSearch(); });
sIn?.addEventListener('input', renderSearch);
sList?.addEventListener('click', e => { if (e.target.closest('a')) closeSearch(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape' && sBox && !sBox.hidden) closeSearch(); });

// tabs (results card)
const tabs = [...document.querySelectorAll('.tab')];
tabs.forEach(t => t.addEventListener('click', () => {
  tabs.forEach(x => { const on = x === t; x.setAttribute('aria-selected', on); document.getElementById(x.getAttribute('aria-controls')).hidden = !on; });
}));

// reviews carousel arrows
const revs = document.getElementById('revs');
document.querySelectorAll('.rev-nav button').forEach(b => b.addEventListener('click', () => revs.scrollBy({ left: b.dataset.dir * revs.clientWidth * .8, behavior: 'smooth' })));

// contact form (not connected yet)
document.getElementById('contactForm')?.addEventListener('submit', e => {
  e.preventDefault();
  const f = e.target, m = document.getElementById('cfMsg');
  if (!f.checkValidity()) { m.textContent = 'Please fill in your name, a valid email and your message.'; return; }
  m.textContent = 'Thanks! This form is a preview and is not connected yet, so nothing was sent.';
});
